import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fetchClientActiveOrderInfo, fetchClientActiveOrderInfoFailure, fetchClientActiveOrderInfoSuccess, fetchClientOrderOverview, fetchClientOrderOverviewFailure, fetchClientOrderOverviewSuccess, fetchClientStats, fetchClientStatsFailure, fetchClientStatsSuccess, fetchRevenueInfo, fetchRevenueInfoFailure, fetchRevenueInfoSuccess, fetchStampingPartnerOrderOverview, fetchStampingPartnerOrderOverviewFailure, fetchStampingPartnerOrderOverviewSuccess, fetchStampingPartnerRevenueInfo, fetchStampingPartnerRevenueInfoFailure, fetchStampingPartnerRevenueInfoSuccess, fetchStampingPartnerStats, fetchStampingPartnerStatsFailure, fetchStampingPartnerStatsSuccess, fetchUsersInfo, fetchUsersInfoFailure, fetchUsersInfoSuccess, fetchMemberStatsVendor , fetchMemberStatsVendorSuccess , fetchMemberStatsVendorFailure, fetchMemberStatsClient , fetchMemberStatsClientSuccess , fetchMemberStatsClientFailure } from './dashboard.action';
import { DashboardService } from '../../core/services/dashboard.service';
import { fetchOverviewInfo, fetchOverviewInfoFailure, fetchOverviewInfoSuccess } from './dashboard.action';
import { SlicePipe } from '@angular/common';

@Injectable()
export class DashboardEffects {

  fetchUsersInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchUsersInfo),
      mergeMap(() =>
        this.dashboardService.getUsersInfo().pipe(
          map((usersInfo) => {
            return fetchUsersInfoSuccess({ usersInfo });
          }),
          catchError((error) =>
            of(fetchUsersInfoFailure({ error }))
          )
        )
      ),
    ),
  );

  fetchRevenueInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchRevenueInfo),
      mergeMap(({postdata}) =>
        this.dashboardService.getRevenueInfo(postdata).pipe(
          map((revenueInfo) => {
            return fetchRevenueInfoSuccess({ revenueInfo })
          }
          ),
          catchError(error => of(fetchRevenueInfoFailure({ error })))
        )
      )
    )
  );

  fetchOverviewInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchOverviewInfo),
      mergeMap(({postdata}) =>
        this.dashboardService.getOrdersOverview(postdata).pipe(
          map(overviewInfo => fetchOverviewInfoSuccess({ overviewInfo })),
          catchError(error => of(fetchOverviewInfoFailure({ error })))
        )
      )
    )
  );

      //FETCH MEMBER STATS - VENDOR
      fetchMemberStatsVendor$ = createEffect(() =>
        this.actions$.pipe(
          ofType(fetchMemberStatsVendor),
          mergeMap(({page , pageSize}) =>
            this.dashboardService.getMemberStatsVendor(page , pageSize).pipe(
              map(memberStats => fetchMemberStatsVendorSuccess({ memberStats })),
              catchError(error => of(fetchMemberStatsVendorFailure({ error })))
            )
          )
        )
      );
      

  /**
   * 
   * CLIENT DASHBOARD EFFECTS
   */
  fetchClientStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchClientStats),
      mergeMap(() =>
        this.dashboardService.getClientStats().pipe(
          map((usersInfo) => {
            return fetchClientStatsSuccess({ usersInfo });
          }),
          catchError((error) =>
            of(fetchClientStatsFailure({ error }))
          )
        )
      ),
    ),
  );

  fetchClientOrderOverview$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchClientOrderOverview),
      mergeMap(({postdata}) =>
        this.dashboardService.getClientOrdersOverview(postdata).pipe(
          map(overviewInfo => fetchClientOrderOverviewSuccess({ overviewInfo })),
          catchError(error => of(fetchClientOrderOverviewFailure({ error })))
        )
      )
    )
  );

  fetchClientActiveOrderInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchClientActiveOrderInfo),
      mergeMap(() =>
        this.dashboardService.getClientActiveOrderInfo().pipe(
          map((activeOrderInfo) => {
            return fetchClientActiveOrderInfoSuccess({ activeOrderInfo });
          }),
          catchError((error) =>
            of(fetchClientActiveOrderInfoFailure({ error }))
          )
        )
      ),
    ),
  );

   //FETCH MEMBER STATS - CLIENTS
   fetchMemberStatsClient$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchMemberStatsClient),
      mergeMap(({page , pageSize}) =>
        this.dashboardService.getMemberStatsClient(page , pageSize).pipe(
          map(memberStats => fetchMemberStatsClientSuccess({ memberStats })),
          catchError(error => of(fetchMemberStatsClientFailure({ error })))
        )
      )
    )
  );

/**
 * STAMPING PARTNER API'S
 */
  fetchStampingPartnerRevenueInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchStampingPartnerRevenueInfo),
      mergeMap(({postdata}) =>
        this.dashboardService.getStampingPartnerRevenueInfo(postdata).pipe(
          map((revenueInfo) => {
            return fetchStampingPartnerRevenueInfoSuccess({ revenueInfo })
          }
          ),
          catchError(error => of(fetchStampingPartnerRevenueInfoFailure({ error })))
        )
      )
    )
  );

  fetchStampingPartnerStats$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchStampingPartnerStats),
      mergeMap(() =>
        this.dashboardService.getStampingPartnerStats().pipe(
          map((usersInfo) => {
            return fetchStampingPartnerStatsSuccess({ usersInfo });
          }),
          catchError((error) =>
            of(fetchStampingPartnerStatsFailure({ error }))
          )
        )
      ),
    ),
  );

  fetchStampingPartnerOrderOverview$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchStampingPartnerOrderOverview),
      mergeMap(({postdata}) =>
        this.dashboardService.getStampingPartnerOrdersOverview(postdata).pipe(
          map(overviewInfo => fetchStampingPartnerOrderOverviewSuccess({ overviewInfo })),
          catchError(error => of(fetchStampingPartnerOrderOverviewFailure({ error })))
        )
      )
    )
  );



  constructor(
    private actions$: Actions,
    private dashboardService: DashboardService
  ) { }
}
